export function toRegex(value: string): RegExp {
  const trim = (str: string, ch: string) => {
    if (str != null) {
      while (str.indexOf(ch) === 0) { str = str.substring(ch.length);}
      while (str.lastIndexOf(ch) === str.length - ch.length) { str = str.substring(0, str.length - ch.length); }
    }
    return str;
  }
  return new RegExp(trim(value, '/'))
}